import React from 'react';
import classnames from 'classnames';
import { useStyles } from './StyledLink.styles';

interface StyledLinkProps extends React.HTMLProps<HTMLAnchorElement> {
  isExternal?: boolean;
}

const StyledLink = ({
  href,
  className,
  children,
  isExternal = false,
  ...otherProps
}: StyledLinkProps) => {
  const classes = useStyles();
  let link = href;
  if (
    isExternal &&
    link &&
    !link.startsWith('http://') &&
    !link.startsWith('https://')
  ) {
    link = `https://${href}`;
  }
  return (
    <a
      {...otherProps}
      href={link}
      className={classnames(classes.styledLink, className)}
    >
      {children}
    </a>
  );
};

export default StyledLink;
